export const updateFriends = (friendsData) => {
    return {
      type: 'UPDATE_FRIENDS',
      payload: friendsData
    };
  };